// This is a placeholder for the live webcast video client after we removed ZoomMtgEmbedded
// TODO: replace when using a new library

export function createClient() {
  return {}
}
